import './styles.scss';

import { SummaryHistoryRow, useSummaryHistory } from '@/features/SummaryHistory';

import SimpleTable from '@/components/SimpleTable';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { SummaryHistoryFormDefinitions } from '../SummaryHistoryForm/types';
import SummaryHistoryTableColumns from '@/features/SummaryHistory/components/SummaryHistoryTable/SummaryHistoryTableColumns';
import SummaryHistoryTableRow from '@/features/SummaryHistory/components/SummaryHistoryTable/SummaryHistoryTableRow';
import { generateSearchableString } from '@/utils';

const SummaryHistoryTable = (): JSX.Element => {
  const [{ summaries: sortedSummaries }] = useSummaryHistory(({ summaries, sortBy, sortDirection, search = '' }) => ({
    summaries: Array.from(summaries.keys())
      .filter((id: string) => {
        if ((search ?? '') === '') return true;
        const accident = summaries.get(id);
        if (!accident) return false;
        const searchable = generateSearchableString(accident, SummaryHistoryFormDefinitions.searchable);
        return searchable.includes(search?.toLowerCase?.());
      })
      .sort((a: string, b: string): number => {
        if (!sortDirection || !sortBy) return 0;
        const sortSummaries = compareSummariesBy(sortBy);
        const result = sortSummaries(summaries.get(a), summaries.get(b));
        if (sortDirection === SortDirectionEnum.Desc) return -result;
        return result;
      }),
  }));

  return (
    <SimpleTable className="SummaryHistoryTable" rows={sortedSummaries} columns={SummaryHistoryTableColumns} row={SummaryHistoryTableRow} />
  );
};

const compareSummariesBy =
  (sortBy: string) =>
  (reportA: SummaryHistoryRow, reportB: SummaryHistoryRow): number => {
    if (!reportA || !reportB) return 0;
    switch (sortBy) {
      case 'CREATED_AT':
        return new Date(reportA.createdAt).getTime() - new Date(reportB.createdAt).getTime();
      case 'NAME':
        return [reportA.dispatcherFirstName, reportA.dispatcherLastName]
          .join(' ')
          .localeCompare([reportB.dispatcherFirstName, reportB.dispatcherLastName].join(' '));
      case 'SHIFT':
        return reportA.dispatcherShift.localeCompare(reportB.dispatcherShift);
      case 'CALL_VOLUME':
        return reportA.callVolume.localeCompare(reportB.callVolume);
      default:
        return 0;
    }
  };

export default SummaryHistoryTable;
